<template>
  <div style="text-align: start; font-weight: bold">
    <div v-if="!isSubscribed">
      Welcome to {{ name }}!
    </div>
    <div v-else>
      Welcome back to {{ name }}!
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCardWelcomeRow',
  props: {
    name: {
      type: String,
      required: true
    },
    isSubscribed: {
      type: Boolean,
      required: true
    }
  }
};
</script>
